import { AppConstant, KeyConstant } from "@/const";
import { ApplicationService } from "@/services";
import { PaginationType } from "@/types/common";
import { useQuery } from "react-query";

const useApplicationList = (props: Partial<PaginationType>) => {
  const { page, size } = props;
  const { data, isLoading, isError } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getApplications, page, size],
    queryFn: () =>
      ApplicationService.getApplicationList({
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        internalF: true,
      }),
    keepPreviousData: true,
    retry: 0,
  });

  const { data: applicationList, ...pagination } = data || {};

  return {
    applicationList: applicationList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
  };
};

export default useApplicationList;
